import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";

export const DATE_FORMAT = 'DATE_FORMAT';
export const DATETIME_FORMAT = 'DATETIME_FORMAT';
export const TIME_FORMAT = 'TIME_FORMAT';
export const SHORT_DATE_FORMAT = 'SHORT_DATE_FORMAT';
export const SHORT_DATETIME_FORMAT = 'SHORT_DATETIME_FORMAT';
export const DATE_INPUT_FORMATS = 'DATE_INPUT_FORMATS';
export const DATETIME_INPUT_FORMATS = 'DATETIME_INPUT_FORMATS';
export const TIME_INPUT_FORMATS = 'TIME_INPUT_FORMATS';


// Initialize Day.js plugins
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);


let translatedFormats = {};

const TRANSLATION_MAP = {
    'a': 'a',
    'A': 'A',
    'b': 'MMM',
    'c': 'YYYY-MM-DD[T]HH:mm:ssZ',
    'd': 'DD',
    'D': 'ddd',
    'e': 'ZZ',
    'E': 'MMMM',
    'f': 'h:mm',
    'F': 'MMMM',
    'g': 'h',
    'G': 'H',
    'h': 'hh',
    'H': 'HH',
    'i': 'mm',
    'I': function (dateObj) {
        return dateObj.isDST() ? '1' : '0';
    },
    'j': {
        '': 'D',
        'S': 'Do',
    },
    'l': 'dddd',
    'L': function (dateObj) {
        return dateObj.isLeapYear() ? '1' : '0';
    },
    'm': 'MM',
    'M': 'MMM',
    'n': 'M',
    'N': 'MMM',
    'o': 'GGGG',
    'O': 'ZZ',
    'P': function (dateObj) {
        const hr = dateObj.hour();
        if (dateObj.minute() === 0) {
            if (hr === 0) {
                return 'midnight';
            } else if (hr === 12) {
                return 'noon';
            } else {
                return dateObj.format('h ') + (hr >= 12 ? 'p.m.' : 'a.m.');
            }
        } else {
            return dateObj.format('h:mm ') + (hr >= 12 ? 'p.m.' : 'a.m.');
        }
    },
    'r': 'ddd, D MMM YYYY HH:mm:ss ZZ',
    's': 'ss',
    'S': function (dateObj) {
        let str = dateObj.format('Do');
        return str.substring(str.length - 2);
    },
    't': '[30]', // Number of days in the month.
    'T': 'z',
    'u': 'SSSSSS',
    'U': 'X',
    'w': 'e',
    'W': 'W',
    'y': 'YY',
    'Y': 'YYYY',
    'z': 'DDD',
    'Z': function (dateObj) {
        let str = dateObj.format('ZZ');
        let sign = str[0] === '-' ? -1 : 1;
        let len = str.length;
        let hrs = parseInt(str.substring(len - 4, len - 2), 10);
        let mins = parseInt(str.substring(len - 2), 10);
        return sign * ((hrs * 3600) + (mins * 60));
    }
};


export function translateFormat(format) {
    if (format instanceof Array) {
        format = format[0];
    }

    let resultFormat = [];
    let currentPart = '';

    let pushPart = function () {
        if (currentPart.length > 0) {
            resultFormat.push(currentPart.replace(/\]\[/g, ''));
            currentPart = '';
        }
    };

    for (let i = 0, len = format.length; i < len; i++) {
        let char = format[i];
        if (char == '\\') {
            currentPart += '[' + format[++i] + ']';
        } else if (TRANSLATION_MAP[char]) {
            let nextPart = TRANSLATION_MAP[char];
            if (typeof(nextPart) == 'string') {
                currentPart += nextPart;
            } else if (typeof(nextPart) == 'function') {
                pushPart();
                resultFormat.push(nextPart);
            } else if (typeof(nextPart) == 'object') {
                let peekChar = format[i + 1];
                if (nextPart[peekChar]) {
                    currentPart += nextPart[peekChar];
                    i++;
                } else if (nextPart['']) {
                    let nextEmpty = nextPart[''];
                    if (typeof(nextEmpty) == 'string') {
                        currentPart += nextEmpty;
                    } else if (typeof(nextEmpty) == 'function') {
                        pushPart();
                        resultFormat.push(nextEmpty);
                    }
                } else {
                    currentPart += '[' + char + ']';
                }
            }
        } else {
            currentPart += '[' + char + ']';
        }
    }
    pushPart();

    return resultFormat;
}

export function getDateFormat(formatName) {
    if (translatedFormats[formatName]) {
        return translatedFormats[formatName];
    } else {
        let fmt = translateFormat(get_format(formatName));
        translatedFormats[formatName] = fmt;
        return fmt;
    }
}

export function format(dateObj, targetFormat) {
    if (dateObj === null || dateObj === undefined) {
        return null;
    }

    if (typeof dateObj === 'string') {
        dateObj = dayjs(dateObj);
    }

    if (targetFormat instanceof Array) {
        let result = '';
        for (let i = 0; i < targetFormat.length; i++) {
            let part = targetFormat[i];
            if (typeof (part) == 'string') {
                result += dateObj.format(part);
            } else if (typeof (part) == 'function') {
                result += part(dateObj);
            }
        }
        return result;
    }

    return dateObj.format(targetFormat);
}
